import { writable, derived } from "svelte/store";

export function modalStore() {
  const initialState = {
    sizeGuideDetails: undefined,
  };

  const modals = writable<Record<string, any>>(initialState);

  return {
    subscribe: modals.subscribe,
    set: modals.set,
    privacyPolicy: derived(modals, modal => {
      return modal.privacyPolicy;
    }),
    sizeGuide: derived(modals, modal => {
      return modal.sizeGuide;
    }),
    sizeGuideDetails: derived(modals, modal => {
      return modal.sizeGuideDetails;
    }),
    setSizeGuideDetails: (details: {
      category: string;
      gender: string;
      bigAndTall: boolean;
      size: string;
      represent?: boolean;
    }) => {
      modals.update(modals => {
        return { ...modals, sizeGuideDetails: details };
      });
    },
    open: (modalName: string) => {
      modals.update(modals => {
        if (modalName === "sizeGuide") {
          return { ...modals, sizeGuide: true };
        } else if (window.location.href.includes("privacy-policy")) {
          return modals;
        } else return { ...modals, [modalName]: true };
      });
    },
    close: () => {
      modals.update(() => {
        return {
          ...initialState,
        };
      });
    },
  };
}
export const modals = modalStore();
